import { FETCH_INFORMATIONS, FETCH_INFORMATIONS_SUCCESS, FETCH_INFORMATIONS_FAIL } from '../actions/types'

const INITIAL_STATE = {
  loading: true,
  data: null
}

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case FETCH_INFORMATIONS:
      return { ...state, loading: true }
    case FETCH_INFORMATIONS_SUCCESS:
      return {
        ...state,
        data: action.payload,
        loading: false
      }
    case FETCH_INFORMATIONS_FAIL:
      return { ...state, loading: false }
    default:
      return (state)
  }
}
